"use client";
import { PersonalitiesSectionProps } from "@/services/home/types";
import PersonalityCard from "./Card";
import { Shell } from "@/components/ui/shell";
import { Fade } from "@/components/ui/animations";

type Props = {
  data: PersonalitiesSectionProps;
};

export default function PersonalityOfTheYear({ data }: Readonly<Props>) {
  if (!data?.honoraries?.length) {
    return null;
  }

  const noOfGrids = data?.honoraries?.length;
  const gap = noOfGrids > 3 ? 6 : 10;

  const gridClasses: {
    [key: number]: string;
  } = {
    3: "lg:grid-cols-3",
    4: "lg:grid-cols-4",
  };

  return (
    <Shell>
      <div className="flex flex-col gap-8 md:gap-12">
        <h3 className="text-3xl text-secondary sm:text-[38px] xl:text-[48px] ltr:font-playfair">
          {data?.title}
        </h3>
        <div
          className={`grid grid-cols-1 sm:grid-cols-1 ${gridClasses[noOfGrids]} gap-6 md:gap-${gap} lg:gap-${gap} sm:justify-items-center lg:justify-items-stretch`}
        >
          {(data?.honoraries ?? [])?.map((data, idx) => {
            return (
              <Fade key={data.name} once={false} delay={idx * 0.2}>
                <PersonalityCard
                  key={idx}
                  name={data?.name ?? ""}
                  year={data?.year ?? ""}
                  img={data?.image_link ?? ""}
                />
              </Fade>
            );
          })}
        </div>
      </div>
    </Shell>
  );
}
